import { INSPECT_ATTR } from '../admin-types/inspectAttrs.js';
import { ENABLE_SHOPPER_BRAND_SETTINGS } from '../api-types/customization.js';
import { BUTTON_BORDER_RADIUS_VAR } from './storefrontCssVariables.js';
/** Matches SECONDARY_FONT_CSS_VAR, which the storefront sets on :root. */
const SECONDARY_FONT_VAR = '--secondary-font';
/**
 * The only styles that apply inside an HTML section's shadow root, alongside
 * the author's own CSS. Shared so anything rendering a section outside the
 * storefront — a screenshot of one, say — reproduces what shoppers see.
 */
export function buildHtmlSectionShadowStyles(enableShopperBrandSettings = ENABLE_SHOPPER_BRAND_SETTINGS) {
    const mediaStyles = enableShopperBrandSettings
        ? `img, video {
    max-width: 100%;
    height: auto;
}
button {
    border-radius: var(${BUTTON_BORDER_RADIUS_VAR});
}`
        : `img {
    max-width: 100%;
    height: auto;
}`;
    return `
body, div, span, p, ul, li {
    font-family: inherit;
    color: inherit;
}
${mediaStyles}
img {
    max-height: 100svh;
    object-fit: contain;
}
[${INSPECT_ATTR.HTML_ROOT}] {
    overflow-x: hidden;
    overflow-x: clip;
}
h1, h2, h3, h4, h5, h6 {
    font-family: var(${SECONDARY_FONT_VAR});
}
::marker {
    color: inherit;
}
li.list-none {
    list-style-type: none;
}
li.list-none::before,
li.list-none::after {
    display: none;
}
`;
}
export const HTML_SECTION_SHADOW_STYLES = buildHtmlSectionShadowStyles();
